import React from "react";

const ScreenContext = React.createContext(null);

const ScreenProvider = (props) => {
  const [width, setWidth] = React.useState(window.innerWidth);
  const [height, setHeight] = React.useState(window.innerHeight);

  React.useEffect(() => {
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleResize = () => {
    setWidth(window.innerWidth);
    setHeight(window.innerHeight);
  };

  const value = { width, height };

  return <ScreenContext.Provider value={value}>{props.children}</ScreenContext.Provider>;
};

export const useScreen = () => React.useContext(ScreenContext);

export default ScreenProvider;
